var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import ContentService from './contentService';
import TranslationService from './translationService';
import ProgressService from './progressService';
class AlbertCommon {
    constructor(props) {
        const { getContentSignature } = props, config = __rest(props, ["getContentSignature"]);
        this.contentSignaturePromise = getContentSignature();
        this.content = new ContentService({
            config,
            getContentSignature: this.contentSignaturePromise,
        });
        this.translation = new TranslationService({
            config,
            getContentSignature: this.contentSignaturePromise,
        });
        this.progress = new ProgressService({
            config,
            contentService: this.content,
            getContentSignature: this.contentSignaturePromise,
        });
    }
}
export default AlbertCommon;
//# sourceMappingURL=index.js.map